import { render, staticRenderFns } from "./FieldTablesContainer.vue?vue&type=template&id=1c0cf33e&scoped=true"
import script from "./FieldTablesContainer.vue?vue&type=script&lang=js"
export * from "./FieldTablesContainer.vue?vue&type=script&lang=js"
import style0 from "./FieldTablesContainer.vue?vue&type=style&index=0&id=1c0cf33e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0cf33e",
  null
  
)

export default component.exports